import { Select } from "@tfg/ui"

import { LANGUAGES } from "~/utils/languages.tsx"

type Props = Omit<React.ComponentProps<typeof Select>, "data">

export const LanguageSelector = (props: Props) => {
  return (
    <Select
      searchable
      data={Object.entries(LANGUAGES).map(([code, lang]) => ({
        label: lang.languageName,
        value: code,
      }))}
      {...props}
    />
  )
}
